import { useState } from "react";

import storageUtils from "../../utils/storageUtils";

export default function useStorage(
  storage,
  key,
  initialValue,
  overwriteInitialValue
) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    const value =
      initialValue instanceof Function ? initialValue() : initialValue;

    try {
      if (overwriteInitialValue) {
        storageUtils.setItem(storage, key, value);
        return value;
      }

      // Get from local storage by key
      const item = storageUtils.getItem(storage, key);
      // Parse stored json or if none return initialValue
      return item ? item : value;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return value;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = value => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      storageUtils.setItem(storage, key, valueToStore);
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };

  return [storedValue, setValue];
}
